/* eslint-disable */
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import MealsRepository from '@/js/common/Domain/Repository/Meals';
import DataLayerAnalytics from "@/js/common/Domain/Service/DataLayerAnalytics";

let MealView = Backbone.View.extend({
	label: 'Питание',
	dataMealsOld: null,
	countryData: null,
	departureCityData: null,
	scrollToElement: function (e) {
		var currenPosition = $(document).scrollTop(),
			$filtersBlock = $('.sideBlock.filters'),
			windowHeight = $(window).height(),
			headerHeight = $('.headerContainer').height(),
			menuHeight = $('.menuContainer').height(),
			elementPosition,
			self = this,
			scrollTo;

		/*Force Open filters*/
		$filtersBlock.addClass('filtersOpened');
		elementPosition = this.$el.offset().top;
		scrollTo = elementPosition;

		headerHeight ? scrollTo -= headerHeight : '';
		menuHeight ? scrollTo -= menuHeight : '';

		scrollTo -= 50;

		setTimeout(function () {
			$filtersBlock.addClass('filtersOpened');
			self.$el.addClass("open");
		}, 1);

		if (elementPosition > currenPosition + windowHeight || elementPosition < currenPosition) {
			$("html,body").animate({scrollTop: scrollTo}, 200);
			return true;
		}

		return false;
	},
	$checkboxes: function () {
		var $checkboxes = $('input[type="checkbox"]', this.$el);
		this.$checkboxes = $checkboxes;
	},
	setValue: function (model) {
		if (!model || !model.length) {
			this.$checkboxes.not('[value="all"]').prop('checked', false);
			this.$checkboxes.filter('[value="all"]').prop('checked', true);
		} else {
			_.each(this.$checkboxes, function (checkbox) {
				var $checkbox = $(checkbox),
					meal = model.get($checkbox.val());

				if (meal && $checkbox.val() != "all") {
					$checkbox.prop('checked', true);
				} else {
					$checkbox.prop('checked', false);
				}
			});
		}
	},
	modelChanged: function (event, model, context) {
		var from, to;
		if (!context || context.initiator !== 'view') {
			this.setValue(model);
		}
	},
	initEvents: function () {
		var self = this;
		this.model.on('change:model', $.proxy(this.modelChanged, this));
	},
	initDomEvents: function () {
		var self = this;
		_.each(this.$checkboxes, function (checkbox) {
			var $checkbox = $(checkbox);
			$checkbox.change($.proxy(self.checkboxChanged, self));
		});
	},
	checkboxChanged: function (event) {
		var defaultMeals,
			dataMeals,
			departureCityType,
			$this = $(event.target),
			meals = [];

		tourCriteriaService.addTourCriteriaChangedField('meals');

		if ($this.is('[value="all"]') && !this.$checkboxes.filter(':checked').length) {
			departureCityType = this.departureCityData && this.departureCityData.get('model') ? this.departureCityData.get('model').get('type') : null;
			defaultMeals = departureCityType ?
				this.countryData.get('model').at(0).get(departureCityType + 'TourCriteria').meals :
				(this.countryData.get('model') ? this.countryData.get('model').at(0).get('tourCriteria').meals : []);

			console.log('defaultMeals', defaultMeals);
			if (!defaultMeals.length) {
				this.$checkboxes.not('[value="all"]').prop('checked', false);
				this.$checkboxes.filter('[value="all"]').prop('checked', true);
			} else {
				_.each(this.$checkboxes.not('[value="all"]'), function (checkbox) {
					var $checkbox = $(checkbox),
						model;

					if (_.contains(defaultMeals, parseInt($checkbox.val(), 10))) {
						$checkbox.prop('checked', true);
						model = MealsRepository.repository.get($checkbox.val());
						if (model) {
							meals.push(model);
						}
					}
				});
			}
		} else if ($this.is('[value="all"]') || !this.$checkboxes.not('[value="all"]').filter(':checked').length) {
			this.$checkboxes.not('[value="all"]').prop('checked', false);
			this.$checkboxes.filter('[value="all"]').prop('checked', true);
		} else {
			this.$checkboxes.filter('[value="all"]').prop('checked', false);
			_.each(this.$checkboxes.not('[value="all"]'), function (checkbox) {
				var $checkbox = $(checkbox),
					model;

				if ($checkbox.is(':checked')) {
					model = MealsRepository.repository.get($checkbox.val());
					if (model) {
						meals.push(model);
					}
				}
			});
		}

		DataLayerAnalytics.toggleFilter($this.prop("checked"), $this.data("layer-name"));

		dataMeals = new MealsRepository(meals);
		dataMeals.manuallyChanged = true;
		this.model.set('model', dataMeals, {initiator: 'view'});
		console.log('Changed meals: ' + dataMeals.pluck('code').join(', '));
	},
	initialize: function (options) {
		this.countryData = options.countryData;
		this.departureCityData = options.departureCityData;
		var self = this,
			model = this.model.get('model');

		this.$checkboxes();
		this.initEvents();
		this.initDomEvents();
		this.setValue(model);
	}
});

export default MealView;